export default __webpack_public_path__ + "static/media/date-icon.5b77b420.svg";